export const stripeClient = Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
